import React from 'react';
import PropTypes from 'prop-types';

export const IframeProductManager = ({ height, getIframeRef, url, isHotel }) =>
    (
        <div className={!isHotel && 'odf-box'}>
            <iframe
                src={url}
                className="iframe_manager"
                style={{ height: height, width: '100%', border: 'none', marginTop: '3px' }}
                scrolling="no"
                ref={getIframeRef()}
            />
        </div>
    );


IframeProductManager.propTypes = {
    height: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    getIframeRef: PropTypes.func,
    isHotel: PropTypes.bool,
};

IframeProductManager.defaultProps = {
    getIframeRef: () => null,
    isHotel: false,
};
